 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		5: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		5: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"221ad2a4823582ebd6240df5ecf28931cdd8682c","1":"styles","2":"a5496168d60035042d0e8301ff526a9ccd114bf6","3":"53aaed2930d3216f1b0c0de47f8e53b019cac2bb","4":"8ccc58481330af2f390a412edcf1d1e67aab125c","9":"component---cache-caches-gatsby-plugin-offline-app-shell-js","10":"component---src-pages-404-js","11":"component---src-pages-about-js","12":"component---src-pages-booking-js","13":"component---src-pages-bronchoscopy-js","14":"component---src-pages-cardiology-js","15":"component---src-pages-chief-js","16":"component---src-pages-contact-js","17":"component---src-pages-dermatovenerology-js","18":"component---src-pages-doctors-js","19":"component---src-pages-functional-diagnostics-js","20":"component---src-pages-general-surgery-js","21":"component---src-pages-hospital-js","22":"component---src-pages-index-js","23":"component---src-pages-lab-js","24":"component---src-pages-laboratory-js","25":"component---src-pages-mini-operations-js","26":"component---src-pages-neurology-js","27":"component---src-pages-news-js","28":"component---src-pages-obstetrics-and-gynecology-js","29":"component---src-pages-oncology-js","30":"component---src-pages-otorhinolaryngology-js","31":"component---src-pages-physiotherapy-js","32":"component---src-pages-polyclinic-js","33":"component---src-pages-privacy-js","34":"component---src-pages-promotion-js","35":"component---src-pages-radiography-js","36":"component---src-pages-radiology-js","37":"component---src-pages-resuscitation-js","38":"component---src-pages-therapy-js","39":"component---src-pages-thoracic-surgery-js","40":"component---src-pages-traumatology-orthopedics-js","41":"component---src-pages-ultrasound-js","42":"component---src-pages-urology-js","43":"component---src-pages-vascular-surgery-js"}[chunkId]||chunkId) + "-" + {"0":"d3a6c935d6de89910459","1":"e9d24b1846c7d6eb9685","2":"16114d35367155d805f8","3":"ec0f1f72752470499879","4":"040e40e887dd2cfc8b04","9":"77466cc0b3ed4dac08eb","10":"067b7f5c5cf0698b53dc","11":"5b9af9d28b824095ca64","12":"e491f21e2254a8eb7964","13":"bcfcb36aefc5e1205e43","14":"8aff5da360a1a95853b5","15":"57a2946bc3ee4a6c7993","16":"3f5c55b9ec41b690c8b2","17":"0cddc34b4cc1c1d115f3","18":"0f2c5e2036220b8faaff","19":"b90fe1441723edd73500","20":"9a6bf21dd65131c48941","21":"0283396164a65efa45c2","22":"c64597e65ea78cdcc9b9","23":"3cbb7179b6eed0a3a445","24":"8f318d9a4e5c0b503ca1","25":"6173d63b2588cec679fc","26":"dec349fbe7bdd929d50f","27":"3046f1e470ed4b017837","28":"5e4af7df8b20e903f411","29":"0bc068f4248f879fde9f","30":"c40e8f892c294ce58d25","31":"b3c40604cdf8eeeaae1b","32":"69a3b3ad2fcba6d9542d","33":"863a3672d4e2125a7740","34":"11fc8b2f84ab7655e78a","35":"04dbc4b093f4bbb089f8","36":"79f55af106223ce91750","37":"181a5c07b33bd6f38ff8","38":"33425af40493df1e3854","39":"3575ecdcd51c4c727575","40":"f38b07b6d9f8eb8eb859","41":"d98a607ed2a8991eceab","42":"7c637298c27897eba236","43":"a7e785bc1dd583ad1eef"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"221ad2a4823582ebd6240df5ecf28931cdd8682c","1":"styles","2":"a5496168d60035042d0e8301ff526a9ccd114bf6","3":"53aaed2930d3216f1b0c0de47f8e53b019cac2bb","4":"8ccc58481330af2f390a412edcf1d1e67aab125c","9":"component---cache-caches-gatsby-plugin-offline-app-shell-js","10":"component---src-pages-404-js","11":"component---src-pages-about-js","12":"component---src-pages-booking-js","13":"component---src-pages-bronchoscopy-js","14":"component---src-pages-cardiology-js","15":"component---src-pages-chief-js","16":"component---src-pages-contact-js","17":"component---src-pages-dermatovenerology-js","18":"component---src-pages-doctors-js","19":"component---src-pages-functional-diagnostics-js","20":"component---src-pages-general-surgery-js","21":"component---src-pages-hospital-js","22":"component---src-pages-index-js","23":"component---src-pages-lab-js","24":"component---src-pages-laboratory-js","25":"component---src-pages-mini-operations-js","26":"component---src-pages-neurology-js","27":"component---src-pages-news-js","28":"component---src-pages-obstetrics-and-gynecology-js","29":"component---src-pages-oncology-js","30":"component---src-pages-otorhinolaryngology-js","31":"component---src-pages-physiotherapy-js","32":"component---src-pages-polyclinic-js","33":"component---src-pages-privacy-js","34":"component---src-pages-promotion-js","35":"component---src-pages-radiography-js","36":"component---src-pages-radiology-js","37":"component---src-pages-resuscitation-js","38":"component---src-pages-therapy-js","39":"component---src-pages-thoracic-surgery-js","40":"component---src-pages-traumatology-orthopedics-js","41":"component---src-pages-ultrasound-js","42":"component---src-pages-urology-js","43":"component---src-pages-vascular-surgery-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"2b5b8bdea876f160e056","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
